import { Loader2 } from "lucide-react"
import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"

export function LoadingState({ className }: { className?: string }) {
  const { t } = useTranslation("common")
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 py-8 text-muted-foreground text-sm",
        className,
      )}
    >
      <Loader2 className="size-4 animate-spin" />
      <span>{t("states.loading")}</span>
    </div>
  )
}
